import { useParams , useLocation } from 'react-router-dom';
import React, {useState, useEffect } from 'react';
import './Base.css';
import StickTile from '../../Tile/StickTile/StickTile';
import dataset from '../../../assets/stk_db/stickfig.json';
import Button from 'react-bootstrap/Button';
import Script from 'react-load-script';



const Gallery  = (props) => {

            
    let {creatorId}  = useParams();
    const  search  = useLocation();
    let stickfig = dataset.stickfig;
    const thumb = require.context('../../../assets/stk_material/Pic/stk_thumbs', true);
    const stk = require.context('../../../assets/stk_material/Stk', true);
    const newnamepng = (cat, name) => "./"+ cat + "/"+ name +".png";
    const newname = (cat, name, ext) => "./"+ cat + "/"+ name + "." + ext;
    const creator_url = (name) => name.replaceAll(" ","_");
    let search_link = search.pathname.split('/id')[0];


    const [width, setWidth] = useState(0)
    const stk_ref = React.createRef();
    console.log(search.pathname.split('/id')[0])

//    useEffect(() => {
//        window.ezstandalone = window.ezstandalone || {};
//        ezstandalone.cmd = ezstandalone.cmd || [];
//        ezstandalone.cmd.push(function() {
//            ezstandalone.displayMore(111);
//        });
    
//    },[])

    function Item({shown, overall, ad, arr, index}) {
        console.log(index)
        console.log(arr)



//   if ((shown < overall) && (ad === shown)) {
   if ((shown < overall) ) {
            console.log(shown)

            return(

                <div className="showButton">

                <p>Showing {shown} / {overall}</p>
                <Button   type="button" variant="outline-secondary" onClick={() => props.length(filteredData.length)} >
                Load more
                </Button>

                </div>
            ) 
//      } else if (index%arr !== (arr-1)) {
//           return(
//        <div>
//          <div id="ezoic-pub-ad-placeholder-111"> 
//          </div>
//          <p>This is a try </p>

//        </div>
//          )

        }
        return(
            <div className="showButton">
            <br></br>
            <p>Showing {overall} / {overall}</p>

            </div>
        ) 
        }

    let filteredData = stickfig.sort((a, b) => a.id > b.id ? -1:1);
    //if no input the return the original
    if (props.filterCategoryName !== "All") {

        filteredData = filteredData .filter(item => item.category === props.filterCategoryName)
    }

    if (props.filterVersionName === "4 or less") {
        filteredData = filteredData .filter(item => item.version !=="5")
    } else if(props.filterVersionName !== "All") {
        filteredData = filteredData .filter(item => item.version === props.filterVersionName)
    }

    if (creatorId !== undefined ) {
        filteredData = filteredData.filter(item => creator_url(item.creator) === creatorId)
    }

    if (props.filterName !== "") {
        filteredData = filteredData.filter(item => item.name.toLowerCase().includes(props.filterName.toLowerCase()))
   }

   let adLength = Math.min(Math.floor(props.showtiles/120), Math.floor(filteredData.length/120))
   let  adArray = Array.from({ length: adLength }, (_, i) => i*120).slice(1).concat(props.showtiles)

//   console.log(Math.max.apply(null, adArray))

    return (

        <div className="Gallery" >

 {/*            <Script
                url="https://www.ezojs.com/ezoic/sa.min.js"
              />*/}

 {/*        { adArray.map((itemArray, index1) => { 


            return(        */}                 
                <div className="StickOverall" ref={stk_ref}>
            
                        
            
                        

{/*             {filteredData.slice(index1*120, itemArray).map((stickfig, index) => { */}
              {filteredData.slice(0, props.showtiles).map((stickfig, index) => { 
                
                return (    
                    
                    <StickTile
                    id={stickfig.id}
                    name={stickfig.name} 
                    creator={stickfig.creator}
                    category= {stickfig.category}
                    link = {stickfig.link} 
                    pic = {thumb(newnamepng(stickfig.category, stickfig.name))}
                    version = {stickfig.version}
                    stk = {stk(newname(stickfig.category,
                        stickfig.name,
                        stickfig.file
                        ))}
                    imgclick={() => this.showInfoTile(index)}
                    pivicon = {stickfig.file==="piv"}
                    search = {search_link}
                    
                    />  
                    
                    
                    
                )
            }
            )} 
 {/*            
                     <Item ad={itemArray} overall= {filteredData.length} index= {index1} shown={props.showtiles}  arr= {adLength} />
                        </div>*/}
                        
                        <Item ad={1} overall= {filteredData.length} index= {0} shown={props.showtiles}  arr= {adLength} />
                        </div>
                   {/*     )


                      } 
                    )} */}


            
        </div>
    )


}

export default Gallery;